exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bookmarks.bookmark--toggle{cursor:pointer;color:var(--color--meta);font-size:.875em}.bookmarks.bookmark--toggle svg{height:1.25rem;width:1.25rem;position:relative;top:3px;fill:var(--color--meta);margin-right:.2rem}", ""]);

// exports
